import { defineMessages } from 'react-intl';

export default defineMessages({
    Header: {
        id: 'cep.renewal.renewalChanges.Header',
        defaultMessage: 'Your cover changes'
    },
    RenewalCoverOptionsHeader: {
        id: 'cep.renewal.renewalChanges.renewalCoverOptionsHeader',
        defaultMessage: 'Your cover options'
    },
    AddOrAmend: {
        id: 'cep.renewal.renewalChanges.AddOrAmend',
        defaultMessage: 'Add or amend your additional cover options'
    },
    CancelAllChanges: {
        id: 'cep.renewal.renewalChanges.CancelAllChanges',
        defaultMessage: 'Cancel all changes'
    },
    ContinueLabel: {
        id: 'cep.renewal.renewalChanges.ContinueLabel',
        defaultMessage: 'Continue'
    },
    CoverCalculator: {
        id: 'cep.renewal.renewalChanges.CoverCalculator',
        defaultMessage: 'Cover Calculator'
    },
    MakeChangeToCalculate: {
        id: 'cep.renewal.renewalChanges.MakeChangeToCalculate',
        defaultMessage: 'Make a change to calculate the new price'
    },
    NewAnnualPrice: {
        id: 'cep.renewal.renewalChanges.NewAnnualPrice',
        defaultMessage: 'New Annual Price'
    }
});
